import PropTypes from 'prop-types';
import React from 'react';
import CardHeader from '../shared/CardHeader';
import '../CardContent.css';
import './MasonCard.css';
import Icon from 'components/Icon';

const MasonCard = ({card}) => (
  <div className="CardContent">
    <CardHeader card={card} />
    <div className="MasonCard__IconContainer">
      <div className="MasonCard__IconCircle">
        <Icon icon={Icon.OPTIONS.SELECT_CHART} className="MasonCard__Icon" />
      </div>
    </div>
  </div>
);

MasonCard.propTypes = {
  card: PropTypes.object.isRequired,
};

export default MasonCard;
